// -------------- WAREHOUSE Page --------------
export const WAREHOUSE_FIELD_ERROR       = 'WAREHOUSE_FIELD_ERROR';
export const WAREHOUSE_FIELD_RESET_ERROR = 'WAREHOUSE_FIELD_RESET_ERROR';
export const WAREHOUSE_GET_ITEM          = 'WAREHOUSE_GET_ITEM';
export const WAREHOUSE_SET_ITEM          = 'WAREHOUSE_SET_ITEM';
export const WAREHOUSE_SET_ALL           = 'WAREHOUSE_SET_ALL';
export const WAREHOUSE_ADD_ITEM          = 'WAREHOUSE_ADD_ITEM';
export const WAREHOUSE_PRODUCT_ITEM      = 'WAREHOUSE_PRODUCT_ITEM';
export const WAREHOUSE_CENTRAL_COUNT     = 'WAREHOUSE_CENTRAL_COUNT';
export const WAREHOUSE_STATE_COUNT       = 'WAREHOUSE_STATE_COUNT';
export const WAREHOUSE_TECHNICIAN_COUNT  = 'WAREHOUSE_TECHNICIAN_COUNT';
export const WAREHOUSE_TECHNICIAN_STATE_COUNT  = 'WAREHOUSE_TECHNICIAN_STATE_COUNT';




// --------- WAREHOUSE Page ---------
export function warehouseFieldError(field, fieldData = {}) {
    return { type: WAREHOUSE_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function warehouseFieldResetError(field, fieldData = {}) {
    return { type: WAREHOUSE_FIELD_RESET_ERROR }
}
export function warehouseSetItem(targetItem) {
    return { type: WAREHOUSE_SET_ITEM, data: targetItem }
}
export function warehouseGetItem(targetItem) {
    return { type: WAREHOUSE_GET_ITEM, data: targetItem }
}
export function warehouseAddItem(addItem) {
    return { type: WAREHOUSE_ADD_ITEM, data: addItem }
}
export function warehouseSetList(allWAREHOUSE) {
    return { type: WAREHOUSE_SET_ALL, data: allWAREHOUSE }
}
export function warehouseCentralCount(central) {
    return { type: WAREHOUSE_CENTRAL_COUNT, data: central }
}
export function warehouseStateCount(state) {
    return { type: WAREHOUSE_STATE_COUNT, data: state }
}
export function warehouseTechnicianCount(technician) {
    return { type: WAREHOUSE_TECHNICIAN_COUNT, data: technician }
}
export function warehouseTechnicianStateCount(technician) {
    return { type: WAREHOUSE_TECHNICIAN_STATE_COUNT, data: technician }
}
